import { WarningStep } from "#/components/carrot-card-cost-share/steps/variants/WarningStep"
import { Link } from "@carrotfertility/carotene-core"
import React from "react"
import { useIntl } from "react-intl"
import { Link as RouterLink } from "react-router-dom"
import { Paths } from "#/utils/Paths"

export function NoFundsAvailableStep(): JSX.Element {
  const intl = useIntl()
  return (
    <WarningStep
      title={intl.formatMessage({ defaultMessage: "You don’t have funds available for this type of expense. " })}
      primaryDescription={intl.formatMessage(
        {
          defaultMessage: "Review your <link>fund categories</link> for more information. "
        },
        {
          link: (linkContent) => (
            <Link
              component={RouterLink}
              to={Paths.FINANCIAL_SUPPORT}
              color="inherit"
              target="_blank"
              rel="noopener noreferrer"
            >
              {linkContent}
            </Link>
          )
        }
      )}
      secondaryDescription={intl.formatMessage(
        {
          defaultMessage: "Please <link>contact us</link> if you think you're seeing this message in error."
        },
        {
          link: (linkContent) => (
            <Link component={RouterLink} to={Paths.CARE_TEAM} color="inherit" target="_blank" rel="noopener noreferrer">
              {linkContent}
            </Link>
          )
        }
      )}
    />
  )
}
